import React from "react";
import axios from "axios";
import { FormLabel } from "@mui/material";
import { withStyles } from "tss-react/mui";
import { connect } from "react-redux";
import defaultIndexStyle from "../../assets/jss/material-dashboard-pro-react/views/defaultIndexStyle";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import SaveButton from "../../components/CustomInput/SaveButton";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { toast } from "react-toastify";

class Passwordchange extends React.Component {
  /**
   * Referentie naar het main formulier
   */
  form = React.createRef();

  state = {
    saving: false,
    hasError: false,
    errors: [],
    formdata: {},
  };

  handleSubmit = (e) => {
    const validPostFields = ["old_password", "password", "password_confirmation"];

    e.preventDefault();

    let formElements = this.form.current.elements;
    let formData = new FormData();

    [...formElements].forEach((e) => {
      if (validPostFields.includes(e.name)) {
        formData.append(e.name, e.value);
      }
    });

    axios.post("/core/gebruikers/passwordreset", formData).then((response) => {
      if (response.data.data.success) {
        window.location.replace("/manager/profiel/");
      } else {
        toast.error(response.data.data.message);
      }
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"wachtwoord veranderen"} tKey={"profiel.passwordchange_title"} />}
        />
        <Card>
          <CardBody>
            <form onSubmit={this.handleSubmit} ref={this.form}>
              <GridContainer>
                <GridItem sm={1} xs={12}>
                  <FormLabel className={classes.labelHorizontal}>
                    <TranslationWrapper tDefault={"Huidig wachtwoord"} tKey={"profiel.old_password"} />
                  </FormLabel>
                </GridItem>
                <GridItem sm={11} xs={12}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    id={"old_password"}
                    inputProps={{
                      type: "password",
                      name: "old_password",
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem sm={1} xs={12}>
                  <FormLabel className={classes.labelHorizontal}>
                    <TranslationWrapper tDefault={"wachtwoord"} tKey={"profiel.password"} />
                  </FormLabel>
                </GridItem>
                <GridItem sm={11} xs={12}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    id={"password"}
                    inputProps={{
                      type: "password",
                      name: "password",
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem sm={1} xs={12}>
                  <FormLabel className={classes.labelHorizontal}>
                    <TranslationWrapper tDefault={"Wachtwoord herhaling"} tKey={"profiel.password_confirmation"} />
                  </FormLabel>
                </GridItem>
                <GridItem sm={11} xs={12}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    id={"password_confirmation"}
                    inputProps={{
                      type: "password",
                      name: "password_confirmation",
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem>
                  <SaveButton
                    buttonText={
                      <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.jamezzForm.savebutton.text_aanpassen"} />
                    }
                    hasError={this.state.hasError}
                    saving={this.state.saving}
                    type={"submit"}
                  />
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(Passwordchange, defaultIndexStyle));
